import { ProjectUser } from '@monorepo/shared/apiClient/types';
import { MenuOption } from '@monorepo/shared/componentsV2/menus/Menu';
import { isOrgAdmin } from './sharedUtils';

const SELF_REVOKE_ORG_ADMIN_TOOLTIP =
  'You cannot demote yourself from organization admin.';

type OrgAdminActionParams = {
  user: ProjectUser;
  isSelf: boolean;
  onSetOrgAdmin: () => void;
};

export function getOrgAdminAction({
  user,
  isSelf,
  onSetOrgAdmin,
}: OrgAdminActionParams): MenuOption {
  const isRevoking = isOrgAdmin(user);
  const disabledTooltip =
    isRevoking && isSelf ? SELF_REVOKE_ORG_ADMIN_TOOLTIP : '';

  return {
    displayName: isRevoking
      ? 'Revoke Organization Admin'
      : 'Make Organization Admin',
    onClick: onSetOrgAdmin,
    disabled: !!disabledTooltip,
    tooltip: disabledTooltip,
    color: isRevoking ? 'danger' : 'primary',
  };
}
